<script lang="ts">
    import Modal from 'hydria/components/Modal.svelte'
    import { gettext as _, resolve, tgettext } from 'hydria/services/gettext'

    import VerticalFieldWidget from '../Widgets/VerticalFieldWidget.svelte'
    import { type ISchemeDef, SCHEMES } from '../models'
    import Scheme from './SchemeDisplay.svelte'

    interface Props {
        saved: string | null
        value: string | null
        disabled?: boolean
        withFloating?: boolean
        save: (v: string) => void
    }

    let { saved: savedValue, value, disabled = false, withFloating = true, save }: Props = $props()

    const UNSET: ISchemeDef = {
        id: 'unset',
        text: tgettext('Non-configuré'),
        textClass: 'text-warning',
    }

    // let scheme: ISchemeDef = $state(UNSET)
    let scheme: ISchemeDef = $derived.by(() => {
        let f = SCHEMES.filter((s) => s.id == value)[0]
        if (f) return f
        return UNSET
    })

    // let savedScheme: ISchemeDef = UNSET
    // $effect(() => {
    //     let f = SCHEMES.filter((s) => s.id == savedValue)[0]
    //     if (!f) f = UNSET
    //     savedScheme = f
    // })

    let label = tgettext('Style visuel')

    let isValid = $derived(value != null && scheme !== UNSET)
    let open = $state(false)

    let isPristine = $derived(value === savedValue)

    function keep(value: string) {
        save(value)
        open = false
    }
</script>

<style>
    .btn-scheme {
        display: grid;
        gap: 0.25rem;
        font-size: 0.85em;
        width: 100%;
    }
</style>

<svelte:window
    onkeydown={(e) => {
        if (e.key == 'Escape' && open) open = false
    }}
/>

<VerticalFieldWidget {label} {isPristine} {isValid}>
    <button type="button" class="btn-scheme btn btn-outline-secondary" {disabled} onclick={() => (open = true)}>
        <Scheme id={value} />
    </button>
</VerticalFieldWidget>

{#if open}
    <Modal close={() => (open = false)}>
        <div class="modal-header">
            <h5>{$resolve(label)}</h5>
        </div>
        <div class="modal-body">
            <div class="container">
                <div class="row row-cols-3">
                    {#each SCHEMES as item}
                        {#if withFloating || !item.floating}
                            <div class="d-grid p-1">
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    class:active={value === item.id}
                                    onclick={() => {
                                        keep(item.id)
                                    }}
                                >
                                    <Scheme id={item.id} />
                                </button>
                            </div>
                        {/if}
                    {/each}
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" onclick={() => (open = false)}>{$_('Fermer')}</button>
        </div>
    </Modal>
{/if}
